import { render, staticRenderFns } from "./ShMoreButton.md?vue&type=template&id=d463515a"
import script from "./ShMoreButton.md?vue&type=script&lang=js"
export * from "./ShMoreButton.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports